import styled from "styled-components/macro";
import { device } from "../../device";

export const StyledContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: 2rem;
	gap: 2rem;

	max-width: 500px;

	background: #ffffff;
	border: 1px solid #ebedee;
	border-radius: 8px;

	margin: 4rem auto;

	@media ${device.tablet} {
		width: 100%;
		margin: 1rem auto;
		img {
			height: 150px;
		}
	}
`;

export const StyledTitle = styled.h3`
	font-weight: 600;
	font-size: 32px;
	line-height: 48px;
	text-align: left;

	color: #575e68;

	@media ${device.tablet} {
		font-size: 28px;
		line-height: 40px;
	}
`;
export const StyledInnerText = styled.p`
	font-size: 18px;
	font-weight: 400;
	line-height: 27px;
	letter-spacing: 0em;
	text-align: center;

	color: #575e68;

	@media ${device.tablet} {
		font-size: 12px;
		line-height: 20px;
	}
`;

export const StyledButton = styled.button`
	&:hover {
		cursor: pointer;
		cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
	}
	padding: 8px 12px;
	background: #3a5558;
	opacity: ${(props) => (props.disabled ? 0.2 : 1)};

	border: 1px solid #3a5558;
	border-radius: 4px;

	color: #fcfcfd;
	font-style: normal;
	font-weight: 500;
	font-size: 14px;
	line-height: 21px;
	width: 120px;
	@media ${device.tablet} {
		width: 80px;
		padding: 6px 10px;
	}
	@media ${device.mobileM} {
		font-size: 10px;
		width: 70px;
	}
`;
export const StyledDoneButton = styled.button`
	background: #f1c232;
	opacity: ${(props) => (props.disabled ? 0.4 : 1)};
	width: 100%;
	padding: 0.5rem 0;

	border: 1px solid #f1c232;
	border-radius: 5px;

	font-weight: 500;
	font-size: 15px;
	line-height: 22px;
	color: #ffffff;
	cursor: pointer;
`;
export const StyledChecklist = styled.ul`
	list-style: none;

	display: flex;
	flex-direction: column;
	align-items: start;
	gap: 1rem;
	${"" /* padding: 32px; */}
	width: 100%;
	li,
	.tooltip {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
		padding: 0px;
		align-self: stretch;
		${"" /* margin: 8px 0; */}
	}
	.tooltip {
		width: 100%;
	}
	@media ${device.tablet} {
		${"" /* padding: 10px; */}
	}
`;

export const StyledListItem = styled.div`
	display: inline-block;
	display: flex;
	align-items: center;
	svg {
		font-size: 18px;
	}
`;

export const StyledLabel = styled.span`
	text-align: left;
	font-weight: 500;
	font-size: 14px;
	line-height: 14px;
	color: #575e68;
	opacity: ${(props) => (props.checked ? 0.5 : 1)};
	margin-left: 16px;
	span {
		font-size: 12px;
		line-height: 18px;
	}
	@media ${device.tablet} {
		font-size: 14px;
	}
	@media ${device.mobileM} {
		font-size: 12px;
	}
`;
